export enum ReferredById {
  REGULAR = 100182,
  AGENTS = 100183,
  AFFILIATE = 100191
}
